import React from "react";

const repoSortOptions = [
  { value: "stars", label: "Most stars" },
  { value: "updated", label: "Recently updated" },
];

const userSortOptions = [
  { value: "", label: "Best match" },
  { value: "followers", label: "Followers" },
  { value: "repositories", label: "Repositories" },
  { value: "joined", label: "Joined" },
];

const ResultsToolbar = ({
  mode,
  keyword,
  total,
  page,
  perPage,
  sortValue,
  onSortChange,
}) => {
  const safeTotal = Math.min(total ?? 0, 1000);
  const start = safeTotal === 0 ? 0 : (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, safeTotal);
  const entity =
    mode === "repositories" ? "repositories" : "users";
  const q = keyword?.trim()
    ? ` for “${keyword.trim()}”`
    : "";

  const options = mode === "repositories" ? repoSortOptions : userSortOptions;

  return (
    <div className="gf-results-toolbar" role="status">
      <p className="gf-results-toolbar__summary">
        Showing <strong>{start}</strong>–<strong>{end}</strong> of{" "}
        <strong>{safeTotal.toLocaleString()}</strong> {entity}
        {q}
      </p>
      <label className="gf-results-toolbar__sort">
        <span className="gf-results-toolbar__sort-label">Sort</span>
        <select
          className="gf-input gf-select gf-select--sm"
          value={sortValue ?? (mode === "repositories" ? "stars" : "")}
          onChange={(e) => onSortChange(e.target.value)}
          aria-label="Sort results"
        >
          {options.map((o) => (
            <option key={o.value === "" ? "_default" : o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default ResultsToolbar;
